import type { SVGProps } from "react";
import * as React from "react";

const SvgBarChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 20a1 1 0 1 0 2 0zm2-10a1 1 0 1 0-2 0zm4 10a1 1 0 1 0 2 0zm2-16a1 1 0 1 0-2 0zM5 20a1 1 0 1 0 2 0zm2-4a1 1 0 1 0-2 0zm6 4V10h-2v10zm6 0V4h-2v16zM7 20v-4H5v4z"
    />
  </svg>
);
export default SvgBarChart;
